import { render, staticRenderFns } from "./VarAdd.vue?vue&type=template&id=f571b670&scoped=true"
import script from "./VarAdd.vue?vue&type=script&lang=js"
export * from "./VarAdd.vue?vue&type=script&lang=js"
import style0 from "./VarAdd.vue?vue&type=style&index=0&id=f571b670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f571b670",
  null
  
)

export default component.exports